import React, { forwardRef } from 'react';
import { FaGraduationCap } from 'react-icons/fa';
import './Education.css';

const Education = forwardRef(({ isInView }, ref) => {
  return (
    <section id="education" className={`Education ${isInView ? 'is-visible' : ''}`} ref={ref}>
      <h2>Education & Training</h2>

      {/* Master’s Degree */}
      <div className="education-item">
        <h3><FaGraduationCap style={{ marginRight: '8px', color: '#2563eb' }} />Master in Cybersecurity</h3>
        <p><strong>University of Pisa</strong> | <a href="https://www.unipi.it" target="_blank" rel="noreferrer">unipi.it</a></p>
        <p>Duration: 10 Aug 2025 – Current</p>
        <p>Location: Pisa, Italy</p>
        <p>Field(s) of Study: Information and Communication Technologies | EQF Level 7</p>
      </div>

      {/* Bachelor’s Degree */}
      <div className="education-item">
        <h3><FaGraduationCap style={{ marginRight: '8px', color: '#2563eb' }} />B.Sc. (Honours) in Computation and Management</h3>
        <p><strong>University of Peradeniya</strong> | <a href="https://www.pdn.ac.lk" target="_blank" rel="noreferrer">pdn.ac.lk</a></p>
        <p>Duration: Jan 2019 – Aug 2023</p>
        <p>Location: Peradeniya, Sri Lanka</p>
        <p>Field(s) of Study: Information and Communication Technologies | EQF Level 6</p>
      </div>
    </section>
  );
});

export default Education;
